import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'
import { Button } from '~/components/ui/button'
import { EmptyState } from '~/components/shared/empty-state'

interface ErrorBoundaryProps {
    children: ReactNode
    /** 폴백 UI를 커스터마이즈할 때 사용한다. */
    fallback?: ReactNode
}

interface ErrorBoundaryState {
    error: Error | null
}

/** 렌더 트리 오류를 잡아 사용자에게 명확한 상태와 재시도를 제공한다. */
export class ErrorBoundary extends Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    state: ErrorBoundaryState = { error: null }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error }
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        // TODO: 관측 백엔드(에러 추적)로 보고한다.
        console.error('ErrorBoundary', error, info)
    }

    private handleReset = (): void => {
        this.setState({ error: null })
    }

    render(): ReactNode {
        if (this.state.error) {
            if (this.props.fallback) return this.props.fallback
            return (
                <div className='p-6'>
                    <EmptyState
                        title='문제가 발생했어요'
                        description='잠시 후 다시 시도해 주세요. 문제가 계속되면 문의해 주세요.'
                        action={
                            <Button
                                variant='secondary'
                                onClick={this.handleReset}>
                                다시 시도
                            </Button>
                        }
                    />
                </div>
            )
        }
        return this.props.children
    }
}
